import { TagIcon } from "app/components/Icons";
import CommonTagSelection from "app/containers/Features/components/CommonTagSelection";
import SelectedTagsPreview from "app/containers/Features/components/CommonTagSelection/SelectedTagsPreview";
import { getTagsByIds } from "app/containers/Features/components/CommonTagSelection/helper";
import { TicketTagsActionsEnum } from "app/containers/Features/containers/Boards/containers/Tickets/TicketFields/types";
import { selectTagList } from "app/redux/selector";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

interface Props {
  tagIds: string[];
  onTagsChange?: (tags: string[], action: TicketTagsActionsEnum) => void;
}

const TagsSelection: React.FC<Props> = ({ tagIds = [], onTagsChange }) => {
  const tagList = useSelector(selectTagList);

  const tagsObj = useMemo(() => {
    return getTagsByIds(tagList, tagIds);
  }, [tagList, tagIds]);

  const handleSelectionChange = (ids: string[]) => {
    const isRemoving = ids.every((id) => tagIds.includes(id));
    const action = isRemoving
      ? TicketTagsActionsEnum.REMOVE
      : TicketTagsActionsEnum.ADD;

    onTagsChange?.(ids, action);
  };
  return (
    <CommonTagSelection
      trigger={
        <button className="flex min-w-0 items-center justify-between w-full px-2 py-2 rounded hover:bg-gray-400 data-[state=open]:border data-[state=open]:border-secondary data-[state=open]:outline-secondary">
          <span className="flex gap-2 text-xs text-secondary items-center">
            <TagIcon size={18} color="#79808A" />
            Tags:
          </span>

          <span className="min-w-0 flex-1 flex justify-end overflow-hidden">
            <SelectedTagsPreview tags={tagsObj} />
          </span>
        </button>
      }
      className="max-w-[237px] py-2"
      selectedTags={tagIds}
      onTagsChange={handleSelectionChange}
      align="end"
    />
  );
};

export default TagsSelection;
